import { NonFunctionProperties } from "@/Common/Models/NonFunctionProperties";
import { CareElementFilterSetting } from "./CareElementFilterSetting";
import { ResultsDurationType } from "./ResultsDurationType";

export class CareComponentFilterSetting {
    public Name: string;
    public IsEnabled: boolean;
    public OutsideTreatmentTarget: boolean;
    public OutsideTreatmentFrequency: boolean;
    public ResultsDurationType: ResultsDurationType;
    public StartDate?: string;
    public EndDate?: string;
    public CareElements: CareElementFilterSetting[];

    constructor(args: NonFunctionProperties<CareComponentFilterSetting>) {
        Object.assign(this, args);
    }
}
